import { deleteRequest, get, post, put } from '../../helpers/apihelpers';

const buildQueryString = (filters = {}) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            params.append(key, value);
        }
    });

    const query = params.toString();
    return query ? `?${query}` : '';
};

export const CreateSubjectService = async (data) => {
    try {
        const result = await post('api/admin/subject/create', data);
        return result;
    } catch (err) {
        return err.response;
    }
};

export const UpdateSubjectService = async (data, id) => {
    try {
        const result = await put(`api/admin/subject/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
};

export const GetSubjectService = async (filters = {}) => {
    try {
        const result = await get(`api/admin/subject/get${buildQueryString(filters)}`);
        return result;
    } catch (err) {
        return err.response;
    }
};

export const DeleteSubjectService = async (id) => {
    try {
        const result = await deleteRequest(`api/admin/subject/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
};
